import React, { useState, useEffect } from 'react';
import SuperAdminHeader from './SuperAdminHeader';
import SuperAdminSidebar from './SuperAdminSidebar';
import ApplicationsTable from '../../features/ApplicationsTable';
import ClientsTable from '../../features/ClientsTable';
import AlumniTable from '../../features/AlumniTable';
import ModeratorsTable from '../../features/ModeratorsTable';
import JunkDashboard from '../../../components/SharedFeature/JunkDashboard';
import AdminReports from '../../features/AdminReports';
import SuperAdminHome from './SuperAdminHome';
import Announcement from '../../../components/Announcement/Announcement';
import PublicChat from '../../../components/PublicChat/PublicChat';
import Mailbox from '../../../components/Mailbox/Mailbox';
import SuperAdminCRM from '../../../components/crm/SuperAdminCRMEnhanced';
import IntroToCostingAndManAcc from '../../../components/training/IntroToCostingAndManAcc';
import DesignABusiness from '../../../components/training/DesignABusiness';
import ProgramHealthCheckDashboard from '../../../components/Programs/ProgramHealthCheckDashboard';
import GrantBasics from '../../../components/Funding/GrantBasics';
import ApplicationTutorials from '../../../components/Funding/ApplicationTutorials';
import SettingsPage from '../../main/SettingsPage';
import LogoutConfirmation from '../../../components/ui/LogoutConfirmation';
import { useAuth } from '../../../context/AuthContext';
import ScalingModules from '../../../components/Modules/ScalingModules';
import CoachesForms from '../../../components/CoachesForm/CoachesForms';
import CapacityBuildingProgram from '../../../components/training/CapacityBuildingProgram';
import ProfilingAnalyticsDashboard from '../../../components/ProfilingForms/ProfilingAnalyticsDashboard';
import HealthDashboard from '../../../components/HealthCheck/HealthDashboard';
import ClientDocumentBrowser from '../../../components/DocumentBank/ClientDocumentBrowser';
import ClientStageUpdater from '../../../components/Admin/ClientStageUpdater';
import Commercialisation from '../../../components/Commercialisation/Commercialisation';
import CommercialisationReadinessChecklist from '../../../components/Commercialisation/CommercialisationReadinessChecklist';
import GTMStrategyPlan from '../../../components/Commercialisation/GTMStrategyPlan';
import StartupLaunchChecklist from '../../../components/Commercialisation/StartupLaunchChecklist';
import CommercialisationDashboard from '../../../components/Commercialisation/CommercialisationDashboard';
import AdminAnalyticsDashboard from '../../../components/Commercialisation/AdminAnalyticsDashboard';
import AdminPanel from '../../../components/Commercialisation/AdminPanel';
import ProductDevelopment from '../../../components/ProductDevelopment/ProductDevelopment';
import MonthlyCoachingReport from '../../../components/Reports/MonthlyCoachingReport';
import AdminManagementTable from './AdminManagementTable';

const TrainingManagement = () => {
  const [activeCourse, setActiveCourse] = useState('business');
  const [userRole] = useState('superAdmin');

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 md:py-8 lg:px-8">
        <div className="mb-6 md:mb-8">
          <h1 className="mb-2 text-2xl font-bold text-black md:text-3xl">Training Management</h1>
        </div>

        <div className="mb-6 rounded-lg border border-gray-200 bg-white shadow-sm md:mb-8">
          <div className="border-b border-gray-200">
            <nav className="flex flex-wrap gap-2 px-4 md:gap-0 md:space-x-8 md:px-6">
              <button
                onClick={() => setActiveCourse('business')}
                className={`flex items-center gap-2 border-b-2 px-1 py-3 text-xs font-medium transition-colors md:py-4 md:text-sm ${
                  activeCourse === 'business'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-600 hover:border-gray-400 hover:text-black'
                }`}
              >
                <span>Design-A-Business</span>
              </button>
              <button
                onClick={() => setActiveCourse('costing')}
                className={`flex items-center gap-2 border-b-2 px-1 py-3 text-xs font-medium transition-colors md:py-4 md:text-sm ${
                  activeCourse === 'costing'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-600 hover:border-gray-400 hover:text-black'
                }`}
              >
                <span>Introduction to Costing & Management Accounting</span>
              </button>
              <button
                onClick={() => setActiveCourse('capacity')}
                className={`flex items-center gap-2 border-b-2 px-1 py-3 text-xs font-medium transition-colors md:py-4 md:text-sm ${
                  activeCourse === 'capacity'
                    ? 'border-blue-600 text-black'
                    : 'border-transparent text-gray-600 hover:border-gray-400 hover:text-black'
                }`}
              >
                <span>Capacity Building Program</span>
              </button>
            </nav>
          </div>

          <div className="p-4 md:p-6">
            {activeCourse === 'business' && <DesignABusiness userRole={userRole} />}
            {activeCourse === 'costing' && <IntroToCostingAndManAcc userRole={userRole} />}
            {activeCourse === 'capacity' && <CapacityBuildingProgram userRole={userRole} />}
          </div>
        </div>
      </div>
    </div>
  );
};

const sectionPlaceholders = {
  dashboard: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <SuperAdminHome />
    </div>
  ),
  'super-admins': (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <div className="py-12 text-center">
        <p className="text-lg font-medium text-gray-600">Super Admin Management</p>
        <p className="mt-2 text-sm text-gray-500">Coming soon</p>
      </div>
    </div>
  ),
  admins: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <AdminManagementTable />
    </div>
  ),
  moderators: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <ModeratorsTable />
    </div>
  ),
  clients: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <ClientsTable />
    </div>
  ),
  alumni: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <AlumniTable />
    </div>
  ),
  applications: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <ApplicationsTable />
    </div>
  ),
  settings: <SettingsPage />,
  coaches: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <CoachesForms />
    </div>
  ),
  reports: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <AdminReports />
    </div>
  ),
  'monthly-coaching-reports': <MonthlyCoachingReport userRole="superAdmin" />,
  'profiling-analytics': <ProfilingAnalyticsDashboard userRole="superAdmin" />,
  announcement: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <Announcement />
    </div>
  ),
  training: <TrainingManagement />,
  'product-development': <ProductDevelopment userRole="superAdmin" />,
  health: (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <ProgramHealthCheckDashboard userRole="superAdmin" />
    </div>
  ),
  'business-health': (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <HealthDashboard userRole="superAdmin" />
    </div>
  ),
  funding: (
    <div className="mx-auto max-w-5xl space-y-6 rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:space-y-8 md:p-6">
      <GrantBasics userRole="superAdmin" />
      <ApplicationTutorials userRole="superAdmin" />
    </div>
  ),
  scalingmodules: <ScalingModules userRole="superAdmin" />,
  commercialisation: <Commercialisation userRole="superAdmin" />,
  'commercialisation-dashboard': <CommercialisationDashboard userRole="superAdmin" />,
  'commercialisation-readiness-checklist': (
    <CommercialisationReadinessChecklist userRole="superAdmin" />
  ),
  'go-to-market-strategy': <GTMStrategyPlan userRole="superAdmin" />,
  'startup-launch-checklist': <StartupLaunchChecklist userRole="superAdmin" />,
  'commercialisation-analytics': <AdminAnalyticsDashboard />,
  'commercialisation-admin-panel': <AdminPanel />,
  crm: <SuperAdminCRM />,
  'document-bank': (
    <ClientDocumentBrowser
      title="Client Document Bank"
      description="Search for any client and manage their document repository from a single workspace."
    />
  ),
  'client-stage-management': (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-lg md:p-8">
      <ClientStageUpdater />
    </div>
  ),
  'junk-management': <JunkDashboard />,
};

const SuperAdminDash = () => {
  const { logout } = useAuth();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [selectedSection, setSelectedSection] = useState('dashboard');
  const [inboxSubsection, setInboxSubsection] = useState('public');
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setSidebarCollapsed(true);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderContent = () => {
    if (selectedSection === 'inbox') {
      return inboxSubsection === 'public' ? <PublicChat /> : <Mailbox />;
    }
    return sectionPlaceholders[selectedSection] || sectionPlaceholders.dashboard;
  };

  const confirmLogout = async () => {
    setShowLogoutConfirm(false);
    await logout();
  };

  return (
    <div className="flex h-screen overflow-hidden bg-white">
      <SuperAdminSidebar
        collapsed={sidebarCollapsed}
        setCollapsed={setSidebarCollapsed}
        selected={selectedSection}
        setSelected={setSelectedSection}
        inboxSubsection={inboxSubsection}
        onInboxSubsectionChange={setInboxSubsection}
      />
      <div className="relative flex min-w-0 flex-1 flex-col">
        <SuperAdminHeader />
        <main className="flex-1 overflow-y-auto bg-transparent p-2 md:p-4">{renderContent()}</main>
      </div>
      <LogoutConfirmation
        isOpen={showLogoutConfirm}
        onConfirm={confirmLogout}
        onCancel={() => setShowLogoutConfirm(false)}
      />
    </div>
  );
};

export default SuperAdminDash;
